/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown>, step: NonNullable<unknown> }} Notifications_Case_Step_Changed_Body_ExpandedInputs */

const en_notifications_case_step_changed_body_expanded = /** @type {(inputs: Notifications_Case_Step_Changed_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The workflow step for case ${i?.caseNumber} is now ${i?.step}.`)
};

const pt_br2_notifications_case_step_changed_body_expanded = /** @type {(inputs: Notifications_Case_Step_Changed_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A etapa do caso ${i?.caseNumber} agora é ${i?.step}.`)
};

/**
* | output |
* | --- |
* | "The workflow step for case {caseNumber} is now {step}." |
*
* @param {Notifications_Case_Step_Changed_Body_ExpandedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_case_step_changed_body_expanded = /** @type {((inputs: Notifications_Case_Step_Changed_Body_ExpandedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Case_Step_Changed_Body_ExpandedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_case_step_changed_body_expanded(inputs)
	return pt_br2_notifications_case_step_changed_body_expanded(inputs)
});